import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiDivider: ThemeOptions['components']['MuiDivider'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.divider,
      '&.MuiDivider-withChildren': {
        textTransform: 'uppercase',
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
        lineHeight: theme.spacing(3),
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
        color: theme.palette.text.primary,
        '&::before, &::after': {
          borderColor: theme.palette.divider
        },
        '.MuiDivider-wrapper': {
          padding: theme.spacing(0, 3),
          '.MuiSvgIcon-root': {
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
            verticalAlign: 'text-top'
          },
          '> :not(:first-of-type)': {
            marginLeft: theme.spacing(2)
          }
        }
      }
    })
  }
};
